'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { faro } from '@grafana/faro-web-sdk'
import { Suspense, use, useEffect } from 'react'

type AnonymousObservabilityUser = { status: 'anonymous' }
type AuthenticatedObservabilityUser = {
  status: 'authenticated'
  email: string
  id: string
}
type ObservabilityUser =
  | AnonymousObservabilityUser
  | AuthenticatedObservabilityUser

export function BrowserObservability({
  userPromise,
}: {
  userPromise: Promise<ObservabilityUser>
}) {
  return (
    <Suspense fallback={null}>
      <IdentifyUser userPromise={userPromise} />
    </Suspense>
  )
}

function IdentifyUser({
  userPromise,
}: {
  userPromise: Promise<ObservabilityUser>
}) {
  const user = use(userPromise)

  useEffect(() => {
    if (user.status === 'authenticated') {
      faro.api.setUser({
        id: user.id,
        email: user.email,
      })
    } else {
      faro.api.resetUser()
    }
  }, [user])

  return null
}
